import { render } from "./UnitTitleButton.vue?vue&type=template&id=e7f9887e&scoped=true"
import script from "./UnitTitleButton.vue?vue&type=script&lang=js"
export * from "./UnitTitleButton.vue?vue&type=script&lang=js"

import "./UnitTitleButton.vue?vue&type=style&index=0&id=e7f9887e&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2025\\tokyo-shoseki\\r7\\gi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7f9887e"]])

export default __exports__